export default {
  cartItems: state => state.items,
  cartTotal: state => state.total,
  totalAmount (state) {
    return state.items.reduce((sum, item) => {
      const price = Number(item.attributes?.price) || 0
      return sum + price * item?.quantity
    }, 0)
  },
}